export default "__VITE_ASSET__Ij1xkLRz__"